import _ from 'lodash';

export function afterUpdateDebounce(func: () => void) {
  return _.debounce(func, CONFIG.afterUpdateDebounceIntervalMilliseconds, {
    leading: true,
    trailing: true,
    maxWait: CONFIG.afterUpdateDebounceMaxWaitMilliseconds
  });
}